import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'core-js/stable'
import './i18n'
import './utils/filters'
import './utils/directives'

import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/browser'

import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'

import App from './App'
import FormGroup from './components/Forms/FormGroup'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import ReceiptsTable from '@/components/receipts/ReceiptsTable'
import Rollbar from 'vue-rollbar'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import VueMeta from 'vue-meta'
import VueProgressBar from 'vue-progressbar'
import VueSweetalert2 from 'vue-sweetalert2'
import VueWait from 'vue-wait'
// Lib imports
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import VuetifyToast from 'vuetify-toast-snackbar'
import _ from 'lodash'
import colors from 'vuetify/es5/util/colors'
import en from 'vuetify/es5/locale/en'
import fr from 'vuetify/es5/locale/fr'
import helpers from './utils/helpers'
import moment from 'moment'
import nl from 'vuetify/es5/locale/nl'
import router from './router'
// Application imports
import store from './store'
import { sync } from 'vuex-router-sync'
import validationAttributes from './validation/attributes'
import validationMessages from './validation/messages'
import vueAwesomeCountdown from 'vue-awesome-countdown'
import vuePositionSticky from 'vue-position-sticky'

// Make lodash globally available
Vue.prototype._ = _
Vue.prototype.helpers = helpers

Vue.config.productionTip = false
const opts = {
  lang: {
    locales: { nl, en, fr },
    current: 'en'
  },
  icons: {
    iconfont: 'fa'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.orange.darken2,
        secondary: colors.orange.darken2
      }
    }
  }
}

const vuetifyObj = new Vuetify(opts)

Vue.use(Vuetify)
Vue.use(vuePositionSticky)
Vue.use(VueMeta)
Vue.use(PerfectScrollbar)
Vue.use(vueAwesomeCountdown, 'countdown')

Vue.use(VueWait)
Vue.use(VueSweetalert2, {
  confirmButtonText: Vue.i18n.translate('Yes'),
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674',
  buttonsStyling: false,
  confirmButtonClass: 'v-btn theme--light v-size--default success',
  cancelButtonClass: 'v-btn theme--light v-size--default'
})

Vue.use(Vuelidate)
Vue.use(VuelidateErrorExtractor, {
  i18n: 'root',
  i18nAttributes: validationAttributes,
  messages: validationMessages
})

Vue.use(Vue2TouchEvents)
Vue.use(require('vue-moment'), {
  moment
})
Vue.use(VueProgressBar, {
  color: '#c76807',
  failedColor: 'red',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
})

Vue.use(Rollbar, {
  accessToken: 'b6d51305b16c4e448636ad48d548d559',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  source_map_enabled: true,
  environment: 'production',
  payload: {
    client: {
      javascript: {
        code_version: '1.0',
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
})

Vue.use(VuetifyToast, {
  $vuetify: vuetifyObj.framework,
  x: 'left',
  timeout: 4000,
  showClose: true,
  closeIcon: 'fal fa-times'
})

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyAQQf1Ih3fFp3z9lKCuD79FAjDKoSzTtFw'
})

// For Validation messages
Vue.component('FormGroup', FormGroup)
Vue.component('formWrapper', templates.FormWrapper)

// Temporary Fix
Vue.component('ReceiptsTable', ReceiptsTable)

Vue.config.errorHandler = (err) => {
  Vue.rollbar.error(err)
}

Sentry.init({
  dsn: 'https://634525da04ee47aa9641acc704ac95a9@sentry.io/2320832',
  integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })]
})

// sync store with router
sync(store, router)
/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  vuetify: new Vuetify(opts),
  store,
  router,
  wait: new VueWait({
    useVuex: true
  }),
  components: { App },
  template: '<App/>'
})
